<pipeline-post-content *ngIf="post.loaded && !post.vip && !view.downloadWall" [post]="post"></pipeline-post-content>